import MainContainerLeftControl from '../../universal_components/MainContainerLeftControl/MainContainerLeftControl';
import styles from './Webinars.module.scss';
import WebinarsYearFilter from './WebinarsAside/WebinarsYearFilter';
import WebinarsList from './WebinarsList/WebinarsList';
import { isMobile } from 'react-device-detect';

const Webinars = () => {
  return (
    <main className={styles.main}>
      <MainContainerLeftControl data={<WebinarsYearFilter />}>
        {isMobile && <WebinarsYearFilter />}
        <WebinarsList />
      </MainContainerLeftControl>
    </main>
  );
};

export default Webinars;
